"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var carDiscountCalculator_module_scss_1 = __importDefault(require("./carDiscountCalculator.module.scss"));
var checkCreditDiscount_1 = __importDefault(require("../checkCreditDiscount/checkCreditDiscount"));
var getCreditDiscountsData_1 = require("../../helpers/catalog/getCreditDiscountsData");
var formatPrice_1 = require("../../helpers/formatPrice");
var CarDiscountCalculator = function (prop) {
    var car_catalog_configurations = prop.car_catalog_configurations, setDiscount = prop.setDiscount, discount = prop.discount;
    var discounts = (0, getCreditDiscountsData_1.getCreditDiscountsData)(car_catalog_configurations);
    return (react_1.default.createElement("div", { className: carDiscountCalculator_module_scss_1.default.discount_calculator__container },
        react_1.default.createElement("div", { className: carDiscountCalculator_module_scss_1.default.discount_calculator__input_list },
            discounts.map(function (elem, index) {
                return (react_1.default.createElement(checkCreditDiscount_1.default, { key: "".concat(elem.title, "_").concat(index), discountValue: elem.discount, description: elem.title, setDiscount: setDiscount }));
            }),
            react_1.default.createElement("div", { className: carDiscountCalculator_module_scss_1.default.discount_calculator__discount_generall_price },
                react_1.default.createElement("p", null, "O\u0431\u0449\u0430\u044F \u0432\u044B\u0433\u043E\u0434\u0430"),
                react_1.default.createElement("span", null,
                    "\u043E\u0442 ",
                    (0, formatPrice_1.formatPrice)(discount),
                    "\u20BD")))));
};
exports.default = CarDiscountCalculator;
